
import Vue from 'vue'
import App from './App'
import store from './vuex/store'
import VueBlu from 'vue-blu'
import 'vue-blu/dist/css/vue-blu.min.css'
Vue.use(VueBlu)
import VueRouter from './router'
import LongPress from './config/longPress.js'
Vue.use(LongPress, {time: 1500})
import './config/rem' //全局引入remjs
import "../static/style/common.scss"; //全局引入公共样式
import Bridge from './service/bridge'; //全局引入原生与h5通信模块
import "../static/style/mintUi.scss" //引入全局修改的mint-ui样式
import VueTouch from 'vue-touch'        
Vue.use(VueTouch, {name: 'v-touch'})
VueTouch.config.swipe = {             
  threshold: 80
}
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
// 引入各个语言配置文件
import cn from './i18n/config/cn';
import en from './i18n/config/en';
import ja from './i18n/config/ja';
// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  // locale: localStorage.getItem('locale') || 'cn', // 语言标识
  // 添加多语言（每一个语言标示对应一个语言文件）
  messages: {
    cn,
    en,
    ja
  }
})
Vue.config.productionTip = false
Vue.prototype.$bridge = Bridge;
/* eslint-disable no-new */
new Vue({
  store: store,
  router: VueRouter,
  i18n,
  render: h => h(App)
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js